import { useEffect, useState } from 'react';
import * as Api from './Api';
export function useEditorContextSiteSettings(namespace) {
    const [state, setState] = useState({});
    const [changes, setChanges] = useState({});
    const [loading, setLoading] = useState(true);
    function load() {
        setLoading(true);
        Api.getAllByKey(namespace)
            .then((data) => {
            const stripedData = Object.entries(data.item).reduce((previousValue, [key, value]) => (Object.assign(Object.assign({}, previousValue), { [key.replace(namespace, '').replaceAll('.', ':')]: value })), {});
            console.log(stripedData);
            return setState(stripedData);
        })
            .finally(() => setLoading(false));
    }
    useEffect(() => {
        load();
    }, [namespace]);
    async function saveFn() {
        const settings = Object.keys(changes).reduce((object, changedKey) => (Object.assign(Object.assign({}, object), { [namespace + changedKey.replaceAll(':', '.')]: state[changedKey] })), {});
        const res = await Api.save(settings);
        setChanges({});
        return res;
    }
    return [{
            item: state,
            setItem: setState,
            trackedChanges: changes,
            setTrackedChanges: setChanges,
            reload: load
        }, saveFn, loading];
}
export function useSiteSettings(namespace, _params = {}) {
    const [state, setState] = useState({});
    const [changes, setChanges] = useState({});
    const [loading, setLoading] = useState(true);
    const params = Object.assign({ strip: true }, _params);
    function load() {
        setLoading(true);
        Api.getAllByKey(namespace)
            .then((data) => {
            const stripedData = Object.keys(data.item).reduce((previousValue, currentValue) => {
                let key = currentValue;
                if (params.strip) {
                    key = key.replace(namespace, '');
                }
                return (Object.assign(Object.assign({}, previousValue), { [key]: data.item[currentValue] }));
            }, {});
            console.log(stripedData);
            return setState(stripedData);
        })
            .finally(() => setLoading(false));
    }
    useEffect(() => {
        load();
    }, [namespace]);
    function setSettings(key, value) {
        const fullKey = params.strip ? namespace + key : key;
        console.log('setSettings(', key, value, ')');
        setState((prev) => (Object.assign(Object.assign({}, prev), { [key]: value })));
        setChanges((prev) => (Object.assign(Object.assign({}, prev), { [fullKey]: value })));
    }
    function save() {
        return Api.save(changes);
    }
    return [state, setSettings, save, loading, load];
}
